import React, { useEffect, useState } from 'react'
import Modal from '../../../../common/modal'
import { Button, Grid, Stack } from '@mui/material'
import { Item } from '../../../../common/snippets'
import DropDownOA from '../../../../common/dropDownOA'
import { CircledRightArrowSvg } from '../../../../common/svg/citcledArrow'
import { focusElemnt, isEmpty, navigation1 } from '../../../../common/helper'
import { connect } from 'react-redux'
import { updateAlertError } from '../../../../../store/common/common_action'
import { autoBrnchTransRecvInsertUpdate } from '../../../../../store/generalSetting/GSAction'
import Alert from '../../../../common/alert'
const AutoTransactionModal = (props) => {
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: '', 
    nextId:''
  })
  const [resetUser, setResetUser] = useState({fromUser:false,toUser:false})
  const [branchReset, setBranchReset] = useState(false)
  const statusList = [{ id: 0, name: 'Inactive' }, { id: 1, name: 'Active' }]
  const { updateModal, autoBrnchTransRecvInsertUpdate,updateAlertError, data:{common},
    dataValues: { editData, isEdit, mdt, headerText, cityList, branchList, userList, vehicleListData, tableData,
    setIsSuccess, setMessage, getTableData } } = props
    const { loginData } = common
    const [row, setRow] = useState(null)
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }

  useEffect(() => {
    focusElemnt('abtFromCity')
  }, [])
  useEffect(() => {
    if (!isEmpty(editData)) {
      setRow(editData)
    } else {
      setRow({IsActive:1})
    }
  }, [editData])
  const handleSave = () => {
    if (!row.hasOwnProperty('FromCityID')||row?.FromCityID===undefined) {
        setShowAlert({ show: true, message: "Please Select The City",nextId: 'abtFromCity' }) 
    }else if (!row.hasOwnProperty('FromBranchID')||row?.FromBranchID===undefined ||row?.FromBranchID==='') {
        setShowAlert({ show: true, message: "Please Select The Branch",nextId: 'abtFromBranch' }) 
    } else if (!row.hasOwnProperty('FromUserID')||row?.FromUserID===undefined||row?.FromUserID==='') {
        setShowAlert({ show: true, message: "Please Select The User",nextId: 'abtFromUser' }) 
    } else if (!row.hasOwnProperty('VehicleID')||row?.VehicleID===undefined) {
        setShowAlert({ show: true, message: "Please Select The Vehicle No.",nextId: 'abtVehicleNo' }) 
    } else if (!row.hasOwnProperty('ToBranchID')||row?.ToBranchID===undefined||row?.ToBranchID==='') {
        setShowAlert({ show: true, message: "Please Select The Branch",nextId: 'abtRecvBranch' }) 
    } else if (!row.hasOwnProperty('ToUserID')||row?.ToUserID===undefined||row?.ToUserID==='') {
        setShowAlert({ show: true, message: "Please Select The User",nextId: 'abtRecvUser' }) 
    } else if (!row.hasOwnProperty('IsActive')||row.IsActive===undefined) {
        setShowAlert({ show: true, message: "Please Select The Status",nextId: 'abtStatus' }) 
    }else{
    let object = {
      TransID: isEdit? row?.TranID: 0,
      CompanyID: loginData?.intCompanyID,
      FromCityID: row?.FromCityID,
      FromBranchID: row?.FromBranchID,
      FromUserID: row?.FromUserID,
      ToCityID: row?.ToCityID,
      ToBranchID: row?.ToBranchID,
      ToUserID: row?.ToUserID,
      IsBranchTransfer: 1,
      IsDelBranchTransfer: 0,
      IsHiredVehicle: 0,
      VehicleNumber: row?.VehicleNo,
      VehicleID: row?.VehicleID,
      IsActive: row?.IsActive,
      Mode: 1,
      UserID: loginData?.intUserID
    }
    let duplicates=tableData.filter((val)=>!isEdit && val.FromBranchID===object.FromBranchID && val.ToBranchID === object.ToBranchID)
    if(duplicates.length>0){
      isEdit ? updateModal(false, mdt.UpdateAutoReceivePopupModal) : updateModal(false, mdt.AutoBrnchTransRecvModal)
      updateAlertError({ show: true, msg: 'Duplicate Entry!', success: false, nextId: 'abtCreateTrnsfrBtn' })
      return
    }
    isEdit ? setMessage('New Auto Branch Transfer & Receive Config.\nSaved Successfully!!') : setMessage('New Auto Receive Config.\nSaved Successfully!')
    autoBrnchTransRecvInsertUpdate(object)?.then((res) => {
        if (res?.status === 'Success') {
            isEdit ? updateModal(false, mdt.UpdateAutoBrnchTransRecvModal) : updateModal(false, mdt.AutoReceivePopupModal)
            setIsSuccess(true)
            getTableData()
            focusElemnt('abtCreateTrnsfrBtn')
        } else {
            isEdit ? updateModal(false, mdt.UpdateAutoReceivePopupModal) : updateModal(false, mdt.AutoBrnchTransRecvModal)
           if(res?.Message.includes('Duplicate entry')){
            updateAlertError({ show: true, msg: 'Duplicate Entry!', success: false, nextId: 'abtCreateTrnsfrBtn' })
           }else{
             updateAlertError({ show: true, msg: 'Sorry! Encountered An Error', success: false, nextId: 'abtCreateTrnsfrBtn' })
           }
        }
    }).catch((err) => {
        console.log("Error:", err)
    })
  }
  }
  const handleCloseAlert = (nextId) => {
    setShowAlert({ show: false, message: '', nextId: "" })
    focusElemnt(nextId)
  }
  const handleToBranchChange = (val) => {
    setRow((prev) => ({ ...prev, ToBranchID: val.id, ToBranch: val.name, ToUserID:'', ToUser:'' }))
    setResetUser((prev)=>({...prev, toUser:false}));
    setTimeout(() => {
      setResetUser((prev)=>({...prev, toUser:true}));
    }, 100);
  }
  const handleFromBranchchange = (val) => {
    setRow((prev) => ({ ...prev, FromBranchID: val.id, FromBranch: val.name, FromUserID:'', FromUser:'' }))
    setResetUser((prev)=>({...prev, fromUser:false}));
    setTimeout(() => {
      setResetUser((prev)=>({...prev, fromUser:true}));
    }, 100);
  }
  return (<>
    <Modal
      headTxt={headerText}
      width={'48%'}
      updateModal={updateModal}
      closeId={"closeButton"}
      modalClass={'booking-popup'}
      modalStyle={modalStyle}
    >
      <Grid container sx={{ padding: '10px 8px 10px 8px' }} >
        <Grid item md={5.7}>
          <Grid container rowSpacing={0.5}>
            <Grid item md={12}>
              <Item>
                <DropDownOA
                  id='abtFromCity'
                  label={"Select Branch Transfer From City"}
                  width="100%"
                  prevId=''
                  nextId='abtFromBranch'
                  searchPlaceholder={`Search From City`}
                  defaultvalue={row?.FromCity || ''}
                  data={cityList || []}
                  idKey={`id`}
                  dataKey={`name`}
                  onSelResetVal={true}
                  disabled={isEdit}
                  onSelect={(val) => {
                    setRow((prev) => ({ ...prev, FromCityID: val.id, FromCity: val.name, ToCityID: val.id, ToCity: val.name,
                    FromBranchID:'', FromBranch:'', ToBranchID:'', ToBranch:'' }))
                    setBranchReset(false);
                    setTimeout(() => {
                      setBranchReset(true)
                    }, 100);
                  }}
                />
              </Item>
            </Grid>
            <Grid item md={12}>
              <Item>
                <DropDownOA
                  id='abtFromBranch'
                  label={"Select Branch Transfer From Branch"}
                  width="100%"
                  prevId='abtFromCity'
                  nextId='abtFromUser'
                  searchPlaceholder={`Search From Branch`}
                  defaultvalue={row?.FromBranch || ''}
                  data={branchList.filter((val) => val.city === row?.FromCityID) || []}
                  idKey={`id`}
                  dataKey={`name`}
                  disabled={isEdit}
                  onSelResetVal={true}
                  resetFlag={branchReset}
                  onSelect={(val)=>handleFromBranchchange(val)}
                />
              </Item>
            </Grid>
            <Grid item md={12}>
              <Item>
                <DropDownOA
                  id='abtFromUser'
                  label={"Select Branch Transfer From User"}
                  width="100%"
                  prevId='abtFromBranch'
                  nextId='abtVehicleNo'
                  searchPlaceholder={`Search From User`}
                  defaultvalue={row?.FromUser || ''}
                  data={userList.filter((val) => val.branch === row?.FromBranchID) || []}
                  idKey={`id`}
                  dataKey={`name`}
                  onSelResetVal={true}
                  resetFlag={resetUser?.fromUser}
                  onSelect={(val) => {
                    setRow((prev) => ({ ...prev, FromUserID: val.id, FromUser: val.name }))
                  }}
                />
              </Item>
            </Grid>
            <Grid item md={12}>
              <Item>
                <DropDownOA
                  id='abtVehicleNo'
                  label={"Select Vehicle Number For Branch Transfer"}
                  width="100%"
                  prevId='abtFromUser'
                  nextId='abtRecvBranch'
                  searchPlaceholder={`Search Vehicle No.`}
                  defaultvalue={row?.VehicleNo || ''}
                  data={vehicleListData || []}
                  idKey={`id`}
                  dataKey={`name`}
                  onSelResetVal={true}
                  onSelect={(val) => {
                    setRow((prev) => ({ ...prev, VehicleID: val.id, VehicleNo: val.name }))
                  }}
                />
              </Item>
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={0.6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <CircledRightArrowSvg />
        </Grid>
        <Grid item md={5.7}>
          <Grid container rowSpacing={0.5}>
            <Grid item md={12}>
              <Item>
                <DropDownOA
                  id='abtRecvCity'
                  label={"Select Branch Transfer Receive By City"}
                  disabled
                  width="100%"
                  defaultvalue={row?.ToCity || ''}
                  data={cityList || []}
                  idKey={`id`}
                  dataKey={`name`}
                />
              </Item>
            </Grid>
            <Grid item md={12}>
              <Item>
                <DropDownOA
                  id='abtRecvBranch'
                  label={"Select Branch Transfer Receive By Branch"}
                  width="100%"
                  prevId='abtVehicleNo'
                  nextId='abtRecvUser'
                  searchPlaceholder={`Search To Branch`}
                  defaultvalue={row?.ToBranch || ''}
                  data={branchList.filter((val) => val.city === row?.ToCityID && val.id !== row?.FromBranchID) || []}
                  idKey={`id`}
                  dataKey={`name`}
                  onSelResetVal={true}
                  resetFlag={branchReset}
                  onSelect={(val)=>handleToBranchChange(val)}
                />
              </Item>
            </Grid>
            <Grid item md={12}>
              <Item>
                <DropDownOA
                  id='abtRecvUser'
                  label={"Select Branch Transfer Receive By User"}
                  width="100%"
                  prevId='abtRecvBranch'
                  nextId='abtStatus'
                  searchPlaceholder={`Search To User`}
                  defaultvalue={row?.ToUser || ''}
                  data={userList.filter((val) => val.branch === row?.ToBranchID && val.id !== row?.FromUserID) || []}
                  idKey={`id`}
                  dataKey={`name`}
                  resetFlag = {resetUser?.toUser}
                  onSelResetVal={true}
                  onSelect={(val) => {
                    setRow((prev) => ({ ...prev, ToUserID: val.id, ToUser: val.name }))
                  }}
                />
              </Item>
            </Grid>
            <Grid item md={12}>
              <Item>
                <DropDownOA
                  id='abtStatus'
                  label={"Status"}
                  width="100%"
                  prevId='abtRecvUser'
                  nextId='abtAddBtn'
                  data={statusList || []}
                  defaultvalue={isEdit? statusList[row?.IsActive]?.name : statusList[1]?.name }
                  searchPlaceholder={`Search Status`}
                  dataKey={`name`}
                  idKey={`id`}
                  isError={row?.IsActive == 0}
                  isSuccess={row?.IsActive == 1}
                  onSelResetVal={true}
                  onSelect={(val) => {
                    setRow((prev) => ({ ...prev, IsActive: val.id }))
                  }}
                />
              </Item>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Stack style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', gap: '10px', padding: '12px 15px 15px 8px', borderTop: '1px solid #ddd' }}>
        <Button
          id="abtCancelBtn"
          style={{ margin: '0', height: "40px" }}
          className="btn cancel-btn"
          variant="outlined"
          color="error"
          onClick={() => {
            isEdit ? updateModal(false, mdt.UpdateAutoBrnchTransRecvModal) : updateModal(false, mdt.AutoBrnchTransRecvModal)
            focusElemnt('abtCreateTrnsfrBtn')
          }}
          onKeyDown={(e) => {
            navigation1(e, 'abtFromCity', 'abtAddBtn');
          }}
        >
          Cancel
        </Button>
        <Button
          id="abtAddBtn"
          style={{ margin: '0px 0px 0px 5px', height: "40px" }}
          className="btn add-btn"
          variant="contained"
          color="error"
          onClick={() => handleSave()}
          onKeyDown={(e) => {
            navigation1(e, 'abtCancelBtn', 'abtStatus');
          }}
        >
          {isEdit ? 'Update' : 'Save'}
        </Button>
      </Stack>

    </Modal>
    {showAlert.show && <Alert msg={showAlert.message} error={true} close={()=>handleCloseAlert(showAlert.nextId)} />}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  autoBrnchTransRecvInsertUpdate, updateAlertError
}
export default connect(mapStateToProps, mapDispatchToProps)(AutoTransactionModal)
